@if (
  {
    shiftToAssign: shiftToAssign$ | async,
    activitiesToAssign: activitiesToAssign$ | async,
    defaultRowHeight: defaultRowHeight$ | async,
    selectedRowIndex: modalInteractionService.selectedRowIndex,
    modalView: modalView$ | async,
  };
  as data
) {
  <div
    [style.min-height.px]="data.defaultRowHeight"
    (click)="
      modalInteractionService.setSelectedUserIdAndRowIndex(
        user.id!,
        mouseOverRowIndex ?? 0
      )
    "
  >
    @for (
      innerRowItem of userData.rows;
      track innerRowItem;
      let innerRowIndex = $index
    ) {
      <div class="innerRow" [style.min-height.px]="data.defaultRowHeight">
        @if (innerRowItem.itemViews.length > 0) {
          <div #wrapper class="d-flex">
            @for (shiftView of innerRowItem.itemViews; track shiftView) {
              <wilson-timeline-auto-size-user-shifts
                [shiftView]="shiftView"
                [userId]="user.id!"
                [showShiftValidation]="false"
                [showActivities]="data.modalView === MODAL_VIEW.ACTIVITY"
                [wrapperEle]="wrapper"
                (selectShiftEvent)="redirectToShiftDetails($event)"
              ></wilson-timeline-auto-size-user-shifts>
            }
          </div>
        }
        @if (data.shiftToAssign || data.activitiesToAssign?.length) {
          <div>
            <wilson-shift-to-assign-card
              [isHovered]="
                userIndex === mouseOverRowIndex ||
                userIndex === data.selectedRowIndex
              "
              [shiftView]="
                innerRowItem.itemViews
                  | timelineFilterShiftToAssignPipe
                    : user.shiftAssignment?.shift?.id!
              "
              [userId]="user.id"
              [isActivitiesView]="data.modalView === MODAL_VIEW.ACTIVITY"
            ></wilson-shift-to-assign-card>
          </div>
        }
        @if (innerRowIndex === 0) {
          <wilson-gantt-chart-time-difference
            [user]="user!"
            [timelineCards]="
              (userData.rows[0]
                | toDateTimeRange: user : [data.shiftToAssign]
                | async) || []
            "
            [isLineVisible]="userIndex === mouseOverRowIndex"
          ></wilson-gantt-chart-time-difference>
        }
        @if (innerRowItem.absences.length > 0) {
          <wilson-timeline-user-absence
            [absences]="innerRowItem.absences"
            [absenceHeight]="COMPACT_ABSENCE_HEIGHT"
          ></wilson-timeline-user-absence>
        }
      </div>
    }
  </div>
}
